<div
  class="product-card-price-container"
  fxLayout="row"
  fxLayoutAlign="end center"
  fxLayoutGap="1rem"
  #parent
  [style.color]="card | method: 'getCardTextColor'">
  <div
    class="product-card-price"
    appFitText
    [hidden]="card | method: 'getHidePrice'"
    [parentContainer]="parent"
    [percentageOfParent]="0.5"
    [style.text-decoration]="(card | method: 'getSalePrice') ? 'line-through' : null"
    [style.opacity]="(card | method: 'getSalePrice') ? '0.8' : '1.0'"
    [style.font-weight]="(card | method: 'getSalePrice') ? '500' : '700'">
    {{ card | method: 'getOriginalPrice' }}
  </div>
  <div
    *ngIf="(card | method: 'getSalePrice') && !(card | method: 'getHidePrice')"
    class="product-card-sale-price"
    appFitText
    [parentContainer]="parent"
    [percentageOfParent]="0.5">
    {{ card | method: 'getSalePrice' }}
  </div>
</div>
